import { useVirtualizer } from '@tanstack/react-virtual'
import { useRef } from 'react'

import ScrollToTopButton from './designSystem/ScrollToTopButton'

interface VirtualizedListProps<T> {
  items: T[]
  renderItem: (item: T) => React.ReactNode
  estimatedItemHeight?: number
  overscan?: number
}

function VirtualizedList<T>({ items, renderItem, estimatedItemHeight = 140, overscan = 5 }: VirtualizedListProps<T>) {
  const parentRef = useRef(null)

  // eslint-disable-next-line react-hooks/incompatible-library
  const rowVirtualizer = useVirtualizer({
    count: items.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => estimatedItemHeight,
    overscan,
  })

  return (
    <div ref={parentRef} className='h-full overflow-y-auto pr-2'>
      <ScrollToTopButton listContainerRef={parentRef} />
      <ul className='relative w-full' style={{ height: rowVirtualizer.getTotalSize() }}>
        {rowVirtualizer.getVirtualItems().map((virtualItem) => (
          <li
            key={virtualItem.key}
            data-index={virtualItem.index}
            ref={rowVirtualizer.measureElement}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              transform: `translateY(${virtualItem.start}px)`,
            }}
          >
            {renderItem(items[virtualItem.index]!)}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default VirtualizedList